/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  CLEAN_BALANCE,
  INVESTMENT_POSITION_REPORT,
  SET_DAILY_BALANCE,
  SET_OVERDRAFT_INFO,
  USER_ACCOUNT_SPLIT_BALANCE,
  USER_BALANCE,
  USER_BALANCE_REQUEST_ERROR,
  USER_CONFIG,
  USER_EXPORT_DOWNLOAD_EXTRACT,
  USER_INCOME_TAX,
  USER_SIDE_BALANCE,
} from '~/actions/actionTypes';

const initialState: reducers.AccountReducer = {
  detail: null,
  detailDocuments: [],
  detailStatements: [],
  devices: [],
  list: [],
  listCount: 0,
  balance: null,
  balanceSideAccount: null,
  detailStatementsSideAccount: [],
  rawCorebank: null,
  incomeTaxStatus: null,
  exportExtractDownloadUrl: null,
  config: [],
  investmentPosition: [],
  investmentPositionCount: 0,
  requestBalanceError: false,
  overdraftInfo: null,
  dailyBalance: [],
  accountSplitBalance: null,
};

const accountReducer = (
  state = initialState,
  action: any
): reducers.AccountReducer => {
  switch (action.type) {
    case USER_BALANCE:
      return {
        ...state,
        balance: action.payload,
        requestBalanceError: false,
      };

    case USER_SIDE_BALANCE:
      return {
        ...state,
        balanceSideAccount: action.payload,
        requestBalanceError: false,
      };

    case USER_BALANCE_REQUEST_ERROR:
      return {
        ...state,
        requestBalanceError: true,
      };

    case CLEAN_BALANCE:
      return {
        ...state,
        detailStatementsSideAccount: null,
        balanceSideAccount: null,
        requestBalanceError: false,
      };

    case USER_INCOME_TAX:
      return {
        ...state,
        incomeTaxStatus: action.payload,
      };

    case USER_EXPORT_DOWNLOAD_EXTRACT:
      return {
        ...state,
        exportExtractDownloadUrl: action.payload,
      };

    case USER_CONFIG:
      return {
        ...state,
        config: action.payload,
      };

    case INVESTMENT_POSITION_REPORT:
      return {
        ...state,
        investmentPosition: action.payload,
        investmentPositionCount: action.payload.length,
      };

    case SET_OVERDRAFT_INFO:
      return {
        ...state,
        overdraftInfo: action.payload,
      };

    case SET_DAILY_BALANCE:
      return {
        ...state,
        dailyBalance: action.payload as models.DailyBalanceItem[],
      };

    case USER_ACCOUNT_SPLIT_BALANCE:
      return {
        ...state,
        accountSplitBalance: action.payload,
      };

    default:
      return state;
  }
};

export default accountReducer;
